const pageNotFoundStrings = {
    seoTitle: "La Estrellita | Page Not Found",
    pageDoesntExist: "This page doesn't exist.",
    goBack: "Please check the URL you have entered or click the button below to return to the home page.",
    homeButton: "Return Home",
};

export default pageNotFoundStrings;
